import React, { useEffect, useRef, useState } from "react";
import confetti from "canvas-confetti";
import { motion } from "framer-motion";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { useNavigate } from "react-router-dom";

const JuegoRuleta = () => {
  const [loading, setLoading] = useState(true);
  const slicesRef = useRef([]);
  const ultimaSeleccion = useRef(null);
  const navigate = useNavigate();
  const ruletaInicializada = useRef(false);
  const [resultado, setResultado] = useState(null);

  useEffect(() => {
    // Orden fijo: premios definidos manualmente
    const opciones = [
      { text: "PREMIO", premio: true },
      { text: "SIN PREMIO", premio: false },
      { text: "SIN PREMIO", premio: false },
      { text: "SIN PREMIO", premio: false },
      { text: "SIN PREMIO", premio: false },
      { text: "SIN PREMIO", premio: false },
      { text: "SIN PREMIO", premio: false },
      { text: "PREMIO", premio: true },
      { text: "SIN PREMIO", premio: false },
      { text: "SIN PREMIO", premio: false },
        { text: "SIN PREMIO", premio: false },
        { text: "SIN PREMIO", premio: false },
        { text: "SIN PREMIO", premio: false },
        { text: "SIN PREMIO", premio: false },
    ];

    const slices = opciones.map((item, index) => ({
      text: item.text,
      message: item.text,
      premio: item.premio,
      value: (index + 1) * 100,
      background: item.premio ? "#28a745" : "#ccc",
      logo: item.premio
        ? "/assets/images/premio.png"
        : "/assets/images/sin-premio.png",
    }));

    slicesRef.current = slices;
    setLoading(false);
  }, []);

  useEffect(() => {
    const $ = window.$ || window.jQuery;
    if (!$.fn.superWheel || $(".wheel").length === 0 || loading) return;

    function getRandomIndexExcludingPrevious(length) {
      let index;
      do {
        index = Math.floor(Math.random() * length);
      } while (index === ultimaSeleccion.current && length > 1);
      ultimaSeleccion.current = index;
      return index;
    }

    function lanzarConfetti() {
      const duration = 5000;
      const end = Date.now() + duration;
      (function frame() {
        confetti({ particleCount: 5, spread: 100, origin: { y: 0.6 } });
        if (Date.now() < end) requestAnimationFrame(frame);
      })();
    }

    if (!ruletaInicializada.current) {
      ruletaInicializada.current = true;

      $(".wheel").superWheel({
        slices: slicesRef.current,
        text: {
          color: "#fff",
          offset: 8,
          letterSpacing: 0,
          orientation: "v",
          arc: true,
        },
        slice: {
          background: "#333",
        },
        line: {
          width: 3,
          color: "#fff",
        },
        outer: {
          width: 8,
          color: "#eaeaea",
        },
        inner: {
          width: 8,
          color: "#eaeaea",
        },
        center: {
          width: 5,
          rotate: true,
        },
        marker: {
          background: "#f39c12",
          animate: true,
        },
        rotates: 40,
        duration: 6000,
      });

      $(".wheel").superWheel("onStart", function () {
        $(".spin-to-win").text("Girando, espera...");
      });

      $(".wheel").superWheel("onComplete", function (ganador) {
        setResultado(ganador);

        $("#winnerName").html(
          ganador.premio
            ? "🎉 FELICIDADES GANASTE UN PREMIO"
            : "🙏 GRACIAS POR PARTICIPAR"
        );

        $("#confettiOverlay").fadeIn(200);
        $("#winnerContainer").fadeIn(400);

        if (ganador.premio) lanzarConfetti();

        setTimeout(() => {
          $("#winnerContainer").fadeOut(400);
          $("#confettiOverlay").fadeOut(400);
          $(".spin-to-win:disabled").prop("disabled", false).text("Gira para elegir");
        }, 8000);
      });
    }

    $(".spin-to-win").off("click").on("click", function (e) {
      e.preventDefault();
      const index = getRandomIndexExcludingPrevious(slicesRef.current.length);
      const slice = slicesRef.current[index];
      $(".wheel").superWheel("start", "value", slice.value);
      $(this).prop("disabled", true);
    });
  }, [loading]);

  return (
    <>
      {loading && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 250 }} alt="Cargando..." />
        </div>
      )}
      <div className="container-fluid">
        {!loading && (
          <motion.div
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: "100%", opacity: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }}
          >
            <div className="roulette-container">
                <div className="connections-container" style={{marginTop: "-50px"}}>
                    <div className="back-container">
                    <button className="back-btn" onClick={() => navigate("/home")}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
                        </svg>
                    </button>
                    </div>
                    <h2 className="connections-title">Prueba tu suerte</h2>
                </div>
              <p style={{marginTop:40}}>Presiona en <b>GIRA PARA GANAR</b> y descubrí si ganás un premio 🎁</p>

              <div id="confettiOverlay"></div>

              <div id="winnerContainer">
                <p id="winnerName"></p>
              </div>

              <div className="ruleta-container">
                <button className="spin-to-win" type="button">Gira para ganar</button>
                <div className="wheel"></div>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </>
  );
};

export default JuegoRuleta;
